import React from 'react'
import Signin from '../../components/Signin'
import Signup from '../../components/Signup'
import SignInUpWidget from './SignInUpWidget'
import CUISigninWidget from './CUISigninWidget'
import CUISignUpWidgetV2 from './CUISignupWidgetV2'
import SignupDetailWidget from './SignupDetailWidget'
import SignInPageWidget from './SignInPageWidget'

const buildWidget = showComponent => function _widget(props) {
  return <SignInUpWidget showComponent={showComponent} {...props} />
}

const SignInWidget = buildWidget(Signin)
const SignUpWidget = buildWidget(Signup)

export {
  SignInWidget,
  CUISigninWidget,
  SignUpWidget,
  CUISignUpWidgetV2,
  SignupDetailWidget,
  SignInPageWidget,
  SignInUpWidget,
}
